import { BuyerGroupAction, BuyerGroupModalAction, BuyerGroupURL } from './BuyerGroupConstants';
import { BuyerGroupObject, BuyerGroupState } from './BuyerGroupTypes';
import { BuyerGroup } from '../../../types';
import { EmptyBuyerGroup } from '../SplitScenario/SplitScenarioConstants';

const initialState: BuyerGroupState = {
  list: [],
  item: {
    ...EmptyBuyerGroup,
  },
  default: {
    ...EmptyBuyerGroup,
  },
  modal: {
    state: false,
    action: '',
  },
  buyers: [],
  tcpas: [],
  typage: [],
  splitscenario: [],
  contractid: [],
  count: [],
  signupColumns: [],
};

export default function(state = initialState, action: any): BuyerGroupState {
  switch (action.type) {
    case BuyerGroupAction.FETCH_BUYERGROUP:
      return {
        ...state,
        list: action.payload.BuyerGroupList,
        tcpas: action.payload.TcpaList,
        buyers: action.payload.BuyerList,
        typage: action.payload.TyPagesList,
      };

    case BuyerGroupAction.SHOW_BUYERGROUP:
      return {
        ...state,
        item: action.payload.item,
        modal: {
          ...action.payload.modal,
        },
      };

    case BuyerGroupAction.HIDE_BUYERGROUP:
      return {
        ...state,
        modal: {
          ...state.modal,
          state: false,
        },
      };

    case BuyerGroupAction.UPDATE_BUYERGROUP_ITEM:
      return {
        ...state,
        item: action.payload.item,
      };

    case BuyerGroupAction.CLONE_BUYERGROUP:
      return {
        ...state,
        item: action.payload.item,
        modal: {
          ...action.payload.modal,
        },
      };

    case BuyerGroupAction.UPDATE_BUYERGROUP_LIST:
      return {
        ...state,
        list: action.payload.BuyerGroupList,
      };

    case BuyerGroupAction.DEFAULT_BUYERGROUP:
      return {
        ...state,
        default: action.payload.data,
      };

    case BuyerGroupAction.SAVE_BUYERGROUP:
      return {
        ...state,
        item: action.payload.item,
        modal: {
          ...action.payload.modal,
        },
      };

    case BuyerGroupAction.DELETE_BUYERGROUP:
      return {
        ...state,
      };

    case BuyerGroupAction.SPLITSCENARIO_BUYERGROUP:
      return {
        ...state,
        splitscenario: action.payload.data,
      };

    case BuyerGroupAction.GET_CONTRACT_ID:
      return {
        ...state,
        contractid: action.payload.data,
      };

    case BuyerGroupAction.GET_COUNT:
      return {
        ...state,
        count: action.payload.data,
      };

    case BuyerGroupAction.GET_SIGNUP_COLUMNS:
      return {
        ...state,
        signupColumns: action.payload.data,
      };

    default:
      return state;
  }
}
